import type { ReactNode } from "react";
import { createPortal } from "react-dom";

export function SidebarPortal({ children }: { children: ReactNode }) {
  const sidebarContainer = document.querySelector("[data-sidebar-portal]");

  if (!sidebarContainer) {
    console.warn("SidebarPortal: sidebar-portal-target not found");
    return null;
  }

  return createPortal(children, sidebarContainer);
}
